import { refHeight, refWidth } from './dimensions';

export const dropShadow = (offsetX: number, offsetY: number, blurRadius: number, shadowOpacity = 0.1) =>
  `drop-shadow(rgba(0,0,0,${shadowOpacity}) ${refWidth(offsetX)}vw ${refHeight(offsetY)}vh ${refWidth(blurRadius)}vw)`;
